const Images = {
    Logo: "/assets/img/logo.png",
    headerLogo: "/assets/img/logo.png",
};

export default Images;
